module.exports = "router-outlet{\n    width: 100%;\n}"